export default __webpack_public_path__ + "media/web-workspace.e87adfba.webp";